import { Device, until } from '@helpers/media';
import Button from '@stories/Components/Buttons/Button/Button';
import React from 'react';
import ReactPaginate from 'react-paginate';
import { useMedia } from 'react-use';
import PaginationStyles from './Pagination.styles';
const Pagination = ({ pageIndex, pageSize, totalCount, onPageChange, variant = 'blue', }) => {
    const isMobile = useMedia(until(Device.Tablet), false);
    const pageRange = isMobile ? 1 : 3;
    return (React.createElement(PaginationStyles.Wrapper, { "data-variant": variant },
        React.createElement(ReactPaginate, { pageCount: Math.ceil(totalCount / pageSize), pageRangeDisplayed: pageRange, marginPagesDisplayed: 1, previousLabel: React.createElement(Button, { buttonType: variant === 'blue' ? 'blue-outline' : 'white-outline', icon: "chevron", iconOnly: true }), nextLabel: React.createElement(Button, { buttonType: variant === 'blue' ? 'blue-outline' : 'white-outline', icon: "chevron", iconOnly: true }), forcePage: pageIndex - 1, hrefBuilder: (page, pageCount) => page >= 1 && page <= pageCount ? `?pageIndex=${page}` : '/', hrefAllControls: true, onPageChange: ({ selected }) => {
                onPageChange(selected + 1);
            } })));
};
export default Pagination;
